var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-radio",on:{"click":function($event){return _vm.onClick()}}},[_c('vs-radio',{attrs:{"vs-value":_vm.vsValue,"vs-name":_vm.vsName,"disabled":_vm.disabled},model:{value:(_vm.bindData),callback:function ($$v) {_vm.bindData=$$v},expression:"bindData"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }